import * as React from "react";
import { cn } from "@/lib/utils";

export const inputClasses =
  "flex h-9 w-full min-w-0 rounded-md border border-input bg-card px-3 py-1 text-sm shadow-xs transition-[color,box-shadow,border-color] outline-none placeholder:text-muted-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20";

export function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return <input type={type} data-slot="input" className={cn(inputClasses, className)} {...props} />;
}

export function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(inputClasses, "h-auto min-h-20 py-2 leading-relaxed", className)}
      {...props}
    />
  );
}

/**
 * Date input. Uses the native picker today (accessible, locale-aware);
 * the value is an ISO yyyy-mm-dd string so it can be swapped for a
 * calendar popover later without touching forms.
 */
export function DateInput({ className, ...props }: Omit<React.ComponentProps<"input">, "type">) {
  return <input type="date" data-slot="date-input" className={cn(inputClasses, "tabular", className)} {...props} />;
}
